export default "__VITE_ASSET__f8053017__"